import React, { useState, useEffect, useContext } from 'react';
import { EnvironmentContext } from '../../EnvironmentContext';
import apiconfig from '../../config/config';
import { TextField, Backdrop, CircularProgress } from '@mui/material';
import ImageUploading from "react-images-uploading";
import APIServices from '../../services/APIServices';
import AlertComponent from '../../Components/Alert/Alert';
import { useDispatch } from 'react-redux';
import ButtonCompo from '../../Components/ButtonComponent/ButtonCompo';
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAccessToken } from '../../Redux/Actions';

const RenderHomeImages = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { environment } = useContext(EnvironmentContext);
    const [defaultImages, setDefaultImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteImageAlert, setDeleteImageAlert] = useState(false)
    const [imagesFormData, setImagesFormData] = useState([]);
    const [mongoId, setMongoId] = useState("");
    const [imagesUpdatedAlert, setImagesUpdatedAlert] = useState(false)
    const [errAlert, setErrAlert] = useState(false);
    const [images, setImages] = useState(defaultImages);
    const [imageError, setImageError] = useState(null);
    const MAX_FILE_SIZE = 5242880;
    const accessToken = useSelector((state) => state.accessToken);

    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }
        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            setIsLoading(true);
            APIServices.setAuthToken(tokenToUse);
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getHomeImages()
                .then((response) => {
                    const fetchedImages = response?.data?.images[(response?.data?.images).length - 1].image_urls || [];
                    // console.log('fetched urls:', response?.data?.images.image_urls)
                    setIsLoading(false)
                    setMongoId(response.data.images[0]._id)
                    setDefaultImages(fetchedImages);
                    setImages(fetchedImages.map(url => ({ dataURL: url })));
                })
                .catch((err) => {
                    setErrAlert(true)
                    console.log('Error fetching home images: ', err)
                });
        }
    }, [dispatch, environment, accessToken, navigate]);

    const handleImageUploading = (imageList, addUpdateIndex) => {
        const imageBody = [];
        if (imageError) {
            setImageError(null);
        }
        setImages(imageList);
        const formData = new FormData();
        formData.append("image", imageList?.[addUpdateIndex]?.file);
        for (var key of formData.entries()) {
            if (key[1]) {
                imageBody.push(key[1]);
            } else {
                return imageBody;
            }

        }
        setImagesFormData((prevArr) => {
            return [...prevArr, ...imageBody];
        });
    };

    const handleCancelIconImages = async (index) => {
        setImageError(null);
        const imageToDelete = images[index];

        // Check if the image has a dataURL that is an S3 URL and delete it from S3
        if (imageToDelete?.dataURL && imageToDelete.dataURL.startsWith('https://')) {
            await deleteImageFromS3(imageToDelete.dataURL, index);
        } else {
            // If it's a local image, just remove it from the state
            setImages((prevArr) => {
                const newArr = [...prevArr];
                newArr.splice(index, 1);
                return newArr;
            });
            setImagesFormData((prevArr) => {
                const newArr = [...prevArr];
                newArr.splice(index, 1);
                return newArr;
            });
        }
    };

    const deleteImageFromS3 = async (s3Url, index) => {
        setIsLoading(true)
        try {
            // Delete the image from S3
            await APIServices.deleteImage(s3Url);
            // console.log("image delete response", response.data);
            setImages((prevArr) => {
                const newPrevArr = [...prevArr];
                newPrevArr.splice(index, 1);
                return newPrevArr;
            });
            setDeleteImageAlert(true);
            setIsLoading(false)
        } catch (err) {
            setErrAlert(true);
            setIsLoading(false)
            console.log("Error:", err);
        }
    };

    const handleSubmitImages = async () => {
        setIsLoading(true);

        if (images.length === 0) {
            alert("Add images");
            setIsLoading(false);
            return;
        }

        const updateImagesAPI = async (images) => {
            // console.log("Images From submit: ", images);
            try {
                const imageUrls = [];
                const uploadPromises = images.map(async (image, index) => {
                    if (image.file) {
                        try {
                            const res = await APIServices.multiImageUpload(image);
                            const multiUploadResponseArr = res?.data?.results;
                            multiUploadResponseArr.forEach((imgObj) => {
                                imageUrls[index] = imgObj.Location;
                            });
                            setIsLoading(false)
                        } catch (err) {
                            setErrAlert(true);
                            console.log('Error uploading images', err);
                            setIsLoading(false)
                            throw err;
                        }
                    } else if (image?.dataURL) {
                        imageUrls[index] = image.dataURL;
                    }
                });

                await Promise.all(uploadPromises);

                const body = {
                    image_urls: imageUrls
                };
                const response = await APIServices.updateHomeImages(body, mongoId);
                setIsLoading(false);
                setImagesUpdatedAlert(true);
            } catch (err) {
                console.log("Error updating images: ", err);
                setIsLoading(false);
                setErrAlert(true);
            }
        };

        updateImagesAPI(images);
    };



    return (
        <div>

            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AlertComponent
                open={deleteImageAlert}
                severity="success"
                onClose={() => setDeleteImageAlert(false)}
                text="Image Deleted Successfully."
            />
            <AlertComponent
                open={imagesUpdatedAlert}
                severity="success"
                onClose={() => setImagesUpdatedAlert(false)}
                text="Images Updated Successfully."
            />

            <div className="container pt-5 trip-image-card">

                <ImageUploading
                    multiple
                    value={images}
                    onChange={handleImageUploading}
                    dataURLKey="dataURL"

                    maxFileSize={MAX_FILE_SIZE}
                >
                    {({ imageList, onImageUpload, dragProps, errors, touched }) => (
                        <div className="upload__image-wrappers">
                            <TextField
                                className="image-upload-input"
                                variant="outlined"
                                inputProps={true}
                                disabled
                                value={
                                    images.length > 0
                                        ? images.map((image) => image.name).join(" ")
                                        : ""
                                }
                                multiline
                                rows={6}
                                readOnly
                                error={errors && errors.maxFileSize}
                                helperText={
                                    errors &&
                                    errors.maxFileSize && (
                                        <span
                                            style={{
                                                color: "red",
                                                fontSize: "12px",
                                                marginLeft: "-10px",
                                                fontFamily: "Poppins",
                                            }}
                                        >
                                            Image uploaded cannot exceed the maximum size of 5MB
                                        </span>
                                    )
                                }
                                InputProps={{
                                    startAdornment: (
                                        <div className="image-preview-itinerary" style={{ display: 'flex' }}>
                                            {images.map((image, index) => (
                                                <div className="image-cancel-icon" key={index}>
                                                    <img
                                                        src={image.dataURL}
                                                        alt={`Images ${index}`}
                                                        className="image-preview img"
                                                        style={{ borderRadius: "10px", width: '140px', height: '110px', margin: '4px' }}
                                                    />
                                                    <DeleteIcon
                                                        fontSize={"small"}
                                                        sx={{ color: "grey" }}
                                                        className="cancel-icon"
                                                        // onClick={() => deleteImageFromS3(image.dataURL, index)}
                                                        onClick={() => handleCancelIconImages(index)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    ),
                                    endAdornment:
                                        images?.length === 6 ? null : (
                                            <ButtonCompo btnOutlined
                                                btnText="Add +"
                                                onClick={() => {
                                                    onImageUpload();

                                                }}
                                                {...dragProps}
                                            />


                                        ),
                                }}
                            />
                            {imageError && (
                                <div
                                    style={{
                                        color: "red",
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {imageError}
                                </div>
                            )}
                        </div>
                    )}
                </ImageUploading>
            </div>
            <div className='pt-5'>
                <ButtonCompo
                    typeOfBtn='file'
                    btnOutlined
                    btnText='Submit'
                    onClick={handleSubmitImages}

                />
            </div>


        </div>
    )
}

export default RenderHomeImages;
